import classNames from "classnames";
import RcDrawer from "rc-drawer";
import type { ReactNode } from "react";

import { t } from "@/i18n-js/instance";
import { legacyClassNames } from "@/react/helpers/cssAnchorHelpers";

import { IconButton } from "../HeaderV3/IconButton";
import { Footer } from "./Footer";

import "./styles.scss";
import { Header } from "./Header";

interface DrawerProps {
  afterVisibleChange?: (open: boolean) => void;
  children?: ReactNode;
  className?: string;
  drawerChildrenClassName?: string;
  fixedHeader?: boolean;
  hideHeader?: boolean;
  maskClosable?: boolean;
  noWrapperPadding?: boolean;
  onChange?: (open?: boolean) => void;
  onClose?: () => void;
  open: boolean;
  title?: ReactNode;
  variant?: "default" | "wide";
  width?: string;
}

/**
 * @deprecated Use `@circle-react-shared/ModalsV2/Drawer` instead.
 */
const Drawer = ({
  open,
  title,
  className,
  hideHeader,
  variant = "default",
  onChange,
  afterVisibleChange,
  onClose,
  children,
  fixedHeader,
  noWrapperPadding,
  maskClosable = false,
  drawerChildrenClassName,
}: DrawerProps) => {
  if (!open) {
    return null;
  }

  return (
    <RcDrawer
      prefixCls="drawer"
      className={classNames(
        legacyClassNames(`drawer--${variant}`, {
          "drawer--no-padding": noWrapperPadding,
        }),
        className,
      )}
      open={open}
      level={null}
      placement="right"
      onChange={onChange}
      afterVisibleChange={afterVisibleChange}
      handler={null}
      onClose={onClose}
      maskClosable={maskClosable}
    >
      {!hideHeader && (
        <Header
          title={title}
          fixed={fixedHeader}
          addHeaderPadding={noWrapperPadding}
          Actions={
            <IconButton
              iconSize={24}
              name="24-close"
              onClick={onClose}
              ariaLabel={t("drawer.close_panel")}
              dataTestId="drawer-close-button"
            />
          }
        />
      )}
      {open && (
        <div
          className={legacyClassNames(
            `drawer__children ${drawerChildrenClassName}`,
          )}
        >
          {children}
        </div>
      )}
    </RcDrawer>
  );
};

Drawer.Header = Header;
Drawer.Footer = Footer;

export { Drawer };
